// extracted by mini-css-extract-plugin
export default {"container":"tech_container__-b2tG","hiddenContainer":"tech_hiddenContainer__UyZO-","loader":"tech_loader__7322W"};